__turbopack_context__.v({
  "dropdownMenuDivider": "iDorca_dropdownMenuDivider",
  "dropdownMenuDividerLogged": "iDorca_dropdownMenuDividerLogged",
  "dropdownMenuItem": "iDorca_dropdownMenuItem",
  "loadingSpinner": "iDorca_loadingSpinner",
  "loadingSpinnerVisible": "iDorca_loadingSpinnerVisible",
  "loginButton": "iDorca_loginButton",
  "menuItemWrapper": "iDorca_menuItemWrapper",
  "popoverContent": "iDorca_popoverContent",
  "titleUpperLogoutWrapper": "iDorca_titleUpperLogoutWrapper",
  "trigger": "iDorca_trigger",
  "triggerLabel": "iDorca_triggerLabel",
  "upperLogoutContainer": "iDorca_upperLogoutContainer",
});
